import { translationStatistics } from "./translationStatistics";
import { canonicalNotificationEmne } from "./canonicalNotificationEmne";

/** Localized label for a topic `emne` (handles aliases). */
export function getNotificationTopicLabel(
  language: keyof typeof translationStatistics,
  emne: string | null | undefined,
): string | null | undefined {
  if (emne == null || String(emne).trim() === "") return emne;
  const canonical = canonicalNotificationEmne(emne);
  const topics = translationStatistics[language]?.notificationTopics;
  if (!Array.isArray(topics)) {
    return emne;
  }
  const row = topics.find(
    (topic) => typeof topic === "object" && topic !== null && topic.emne === canonical,
  );
  return typeof row === "object" && row !== null && "label" in row ? String(row.label) : emne;
}
